import React from "react";

import s from "./CognitoContainer.module.scss";

interface IProps{
	children: JSX.Element;
}

export const CognitoContainer = ({ children }: IProps): JSX.Element => (<div className={s.cognitoContainer}>{children}</div>);
